import { useMemo } from 'react';

import { useWindowSize } from '@/common/hooks/useWindowSize';
import { useThumbnail } from '@/hooks/ProductImageCarousel/useThumbnail';
import { transparentPlaceholder } from '@/util/images';

import { useStyle } from '@/classify';
import Image from '../Image';
import defaultClasses from './thumbnail.module.css';

const DEFAULT_THUMBNAIL_HEIGHT = 128;
const DEFAULT_THUMBNAIL_WIDTH = 128;

const Thumbnail = props => {
  const classes = useStyle(defaultClasses, props.classes);

  const {
    alt,
    title,
    isActive,
    item: { file, label, url },
    onClickHandler,
    itemIndex,
  } = props;

  const talonProps = useThumbnail({
    onClickHandler,
    itemIndex,
  });

  const { handleClick } = talonProps;

  const windowSize = useWindowSize();
  const isDesktop = windowSize.innerWidth >= 1024;

  const thumbnailImage = useMemo(() => {
    return url ? (
      <Image
        alt={alt}
        title={title}
        classes={{
          root: classes.image,
        }}
        height={DEFAULT_THUMBNAIL_HEIGHT}
        resource={url}
        width={DEFAULT_THUMBNAIL_WIDTH}
      />
    ) : (
      <Image
        alt={alt}
        title={title}
        classes={{
          root: classes.image,
        }}
        src={transparentPlaceholder}
      />
    );
  }, [url, isDesktop, alt, classes.image, title]);

  return (
    <span
      className={isActive ? classes.rootSelected : classes.root}
      onClick={handleClick}
      role='button'
      aria-hidden='true'
    >
      {/* {thumbnailImage} */}
    </span>
  );
};

export default Thumbnail;
